/* eslint-disable import/prefer-default-export */
import '@fontsource-variable/raleway'

import './src/styles/global.css'
